import React from 'react';

export const InputHint = ({ hint }: { hint?: string }) => {
  if (!hint) return null;
  return (
    <span className="text-xs leading-[14px] text-neutral-500">{hint}</span>
  );
};

export default InputHint;
